<div class="container-width text-center m-2">
    <h6 class="trade mb-1 fs-6">
        {{ translation.t('footer', 'copyright') }}
    </h6>
    
  <div class="marquee-wrapper">
        <div class="marquee-text">
            {{ translation.t('footer', 'marquee') }}
        </div>
    </div>
</div>